import { default as indexQaYbUaUA0pMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/auth/index.vue?macro=true";
import { default as indexyPpalJm5YBMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as indexCFAX1TcFxtMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/index/index.vue?macro=true";
import { default as orderuO1cleHfGWMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/index/order.vue?macro=true";
import { default as orderSuccesssAZP0ccskYMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/index/orderSuccess.vue?macro=true";
import { default as index3XEp42cD9RMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/index.vue?macro=true";
import { default as attributeBaseDataCohQCxcIrEMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/configurator/attributes/[id]/attributeBaseData.vue?macro=true";
import { default as _91id_937QE8Yuw0H9Meta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/configurator/attributes/[id].vue?macro=true";
import { default as componentBaseDataWWiqVZJGoXMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/configurator/components/[id]/componentBaseData.vue?macro=true";
import { default as _91id_93QINsi8a8bCMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/configurator/components/[id].vue?macro=true";
import { default as indexVAyi3yFYeXMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/configurator/components/index.vue?macro=true";
import { default as variantBaseDataKRT7Uk9NZpMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/configurator/variants/[id]/variantBaseData.vue?macro=true";
import { default as _91id_9329AqRetuctMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/configurator/variants/[id].vue?macro=true";
import { default as indexs7riu3U09iMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/configurator/variants/index.vue?macro=true";
import { default as configurator3SAtvbbitSMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/configurator.vue?macro=true";
import { default as indexJ1yuYWvkJmMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/index.vue?macro=true";
import { default as orderBaseDataos1iUej1FoMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/orders/[id]/orderBaseData.vue?macro=true";
import { default as _91id_93nOAjDWouSHMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/orders/[id].vue?macro=true";
import { default as indexvCI78MyzWAMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/orders/index.vue?macro=true";
import { default as languageEBOZlKblGyMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/settings/language.vue?macro=true";
import { default as _91id_93HdUcJMrijrMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as indexIVUg8IBdJqMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as rolesSRaiIq4qvlMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/settings/roles.vue?macro=true";
import { default as settingsdaMmZBXRTzMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/settings.vue?macro=true";
import { default as userActivitiesBFtbXzBSz5Meta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/users/[id]/userActivities.vue?macro=true";
import { default as userBaseDataYlADgryv5tMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/users/[id]/userBaseData.vue?macro=true";
import { default as userCommunicationsCkkvdbwHoUMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/users/[id]/userCommunications.vue?macro=true";
import { default as _91id_93av9JmgWDuRMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/users/[id].vue?macro=true";
import { default as indexXO1WDR2g8vMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/users/index.vue?macro=true";
import { default as usersXwvepQk4frMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/users.vue?macro=true";
import { default as servicedgJ9UzNFaaMeta } from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service.vue?macro=true";
export default [
  {
    name: indexQaYbUaUA0pMeta?.name ?? "auth",
    path: indexQaYbUaUA0pMeta?.path ?? "/auth",
    meta: indexQaYbUaUA0pMeta || {},
    alias: indexQaYbUaUA0pMeta?.alias || [],
    redirect: indexQaYbUaUA0pMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/auth/index.vue").then(m => m.default || m)
  },
  {
    name: indexyPpalJm5YBMeta?.name ?? "auth-social-organisation-provider",
    path: indexyPpalJm5YBMeta?.path ?? "/auth/social/:organisation()/:provider()",
    meta: indexyPpalJm5YBMeta || {},
    alias: indexyPpalJm5YBMeta?.alias || [],
    redirect: indexyPpalJm5YBMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/auth/social/[organisation]/[provider]/index.vue").then(m => m.default || m)
  },
  {
    path: index3XEp42cD9RMeta?.path ?? "/",
    children: [
  {
    name: indexCFAX1TcFxtMeta?.name ?? "index",
    path: indexCFAX1TcFxtMeta?.path ?? "",
    meta: indexCFAX1TcFxtMeta || {},
    alias: indexCFAX1TcFxtMeta?.alias || [],
    redirect: indexCFAX1TcFxtMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/index/index.vue").then(m => m.default || m)
  },
  {
    name: orderuO1cleHfGWMeta?.name ?? "index-order",
    path: orderuO1cleHfGWMeta?.path ?? "order",
    meta: orderuO1cleHfGWMeta || {},
    alias: orderuO1cleHfGWMeta?.alias || [],
    redirect: orderuO1cleHfGWMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/index/order.vue").then(m => m.default || m)
  },
  {
    name: orderSuccesssAZP0ccskYMeta?.name ?? "index-orderSuccess",
    path: orderSuccesssAZP0ccskYMeta?.path ?? "orderSuccess",
    meta: orderSuccesssAZP0ccskYMeta || {},
    alias: orderSuccesssAZP0ccskYMeta?.alias || [],
    redirect: orderSuccesssAZP0ccskYMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/index/orderSuccess.vue").then(m => m.default || m)
  }
],
    name: index3XEp42cD9RMeta?.name ?? undefined,
    meta: index3XEp42cD9RMeta || {},
    alias: index3XEp42cD9RMeta?.alias || [],
    redirect: index3XEp42cD9RMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/index.vue").then(m => m.default || m)
  },
  {
    path: servicedgJ9UzNFaaMeta?.path ?? "/service",
    children: [
  {
    name: configurator3SAtvbbitSMeta?.name ?? "service-configurator",
    path: configurator3SAtvbbitSMeta?.path ?? "configurator",
    children: [
  {
    name: _91id_937QE8Yuw0H9Meta?.name ?? "service-configurator-attributes-id",
    path: _91id_937QE8Yuw0H9Meta?.path ?? "attributes/:id()",
    children: [
  {
    name: attributeBaseDataCohQCxcIrEMeta?.name ?? "service-configurator-attributes-id-attributeBaseData",
    path: attributeBaseDataCohQCxcIrEMeta?.path ?? "attributeBaseData",
    meta: attributeBaseDataCohQCxcIrEMeta || {},
    alias: attributeBaseDataCohQCxcIrEMeta?.alias || [],
    redirect: attributeBaseDataCohQCxcIrEMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/configurator/attributes/[id]/attributeBaseData.vue").then(m => m.default || m)
  }
],
    meta: _91id_937QE8Yuw0H9Meta || {},
    alias: _91id_937QE8Yuw0H9Meta?.alias || [],
    redirect: _91id_937QE8Yuw0H9Meta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/configurator/attributes/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93QINsi8a8bCMeta?.name ?? "service-configurator-components-id",
    path: _91id_93QINsi8a8bCMeta?.path ?? "components/:id()",
    children: [
  {
    name: componentBaseDataWWiqVZJGoXMeta?.name ?? "service-configurator-components-id-componentBaseData",
    path: componentBaseDataWWiqVZJGoXMeta?.path ?? "componentBaseData",
    meta: componentBaseDataWWiqVZJGoXMeta || {},
    alias: componentBaseDataWWiqVZJGoXMeta?.alias || [],
    redirect: componentBaseDataWWiqVZJGoXMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/configurator/components/[id]/componentBaseData.vue").then(m => m.default || m)
  }
],
    meta: _91id_93QINsi8a8bCMeta || {},
    alias: _91id_93QINsi8a8bCMeta?.alias || [],
    redirect: _91id_93QINsi8a8bCMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/configurator/components/[id].vue").then(m => m.default || m)
  },
  {
    name: indexVAyi3yFYeXMeta?.name ?? "service-configurator-components",
    path: indexVAyi3yFYeXMeta?.path ?? "components",
    meta: indexVAyi3yFYeXMeta || {},
    alias: indexVAyi3yFYeXMeta?.alias || [],
    redirect: indexVAyi3yFYeXMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/configurator/components/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_9329AqRetuctMeta?.name ?? "service-configurator-variants-id",
    path: _91id_9329AqRetuctMeta?.path ?? "variants/:id()",
    children: [
  {
    name: variantBaseDataKRT7Uk9NZpMeta?.name ?? "service-configurator-variants-id-variantBaseData",
    path: variantBaseDataKRT7Uk9NZpMeta?.path ?? "variantBaseData",
    meta: variantBaseDataKRT7Uk9NZpMeta || {},
    alias: variantBaseDataKRT7Uk9NZpMeta?.alias || [],
    redirect: variantBaseDataKRT7Uk9NZpMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/configurator/variants/[id]/variantBaseData.vue").then(m => m.default || m)
  }
],
    meta: _91id_9329AqRetuctMeta || {},
    alias: _91id_9329AqRetuctMeta?.alias || [],
    redirect: _91id_9329AqRetuctMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/configurator/variants/[id].vue").then(m => m.default || m)
  },
  {
    name: indexs7riu3U09iMeta?.name ?? "service-configurator-variants",
    path: indexs7riu3U09iMeta?.path ?? "variants",
    meta: indexs7riu3U09iMeta || {},
    alias: indexs7riu3U09iMeta?.alias || [],
    redirect: indexs7riu3U09iMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/configurator/variants/index.vue").then(m => m.default || m)
  }
],
    meta: configurator3SAtvbbitSMeta || {},
    alias: configurator3SAtvbbitSMeta?.alias || [],
    redirect: configurator3SAtvbbitSMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/configurator.vue").then(m => m.default || m)
  },
  {
    name: indexJ1yuYWvkJmMeta?.name ?? "service",
    path: indexJ1yuYWvkJmMeta?.path ?? "",
    meta: indexJ1yuYWvkJmMeta || {},
    alias: indexJ1yuYWvkJmMeta?.alias || [],
    redirect: indexJ1yuYWvkJmMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93nOAjDWouSHMeta?.name ?? "service-orders-id",
    path: _91id_93nOAjDWouSHMeta?.path ?? "orders/:id()",
    children: [
  {
    name: orderBaseDataos1iUej1FoMeta?.name ?? "service-orders-id-orderBaseData",
    path: orderBaseDataos1iUej1FoMeta?.path ?? "orderBaseData",
    meta: orderBaseDataos1iUej1FoMeta || {},
    alias: orderBaseDataos1iUej1FoMeta?.alias || [],
    redirect: orderBaseDataos1iUej1FoMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/orders/[id]/orderBaseData.vue").then(m => m.default || m)
  }
],
    meta: _91id_93nOAjDWouSHMeta || {},
    alias: _91id_93nOAjDWouSHMeta?.alias || [],
    redirect: _91id_93nOAjDWouSHMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/orders/[id].vue").then(m => m.default || m)
  },
  {
    name: indexvCI78MyzWAMeta?.name ?? "service-orders",
    path: indexvCI78MyzWAMeta?.path ?? "orders",
    meta: indexvCI78MyzWAMeta || {},
    alias: indexvCI78MyzWAMeta?.alias || [],
    redirect: indexvCI78MyzWAMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/orders/index.vue").then(m => m.default || m)
  },
  {
    name: settingsdaMmZBXRTzMeta?.name ?? "service-settings",
    path: settingsdaMmZBXRTzMeta?.path ?? "settings",
    children: [
  {
    name: languageEBOZlKblGyMeta?.name ?? "service-settings-language",
    path: languageEBOZlKblGyMeta?.path ?? "language",
    meta: languageEBOZlKblGyMeta || {},
    alias: languageEBOZlKblGyMeta?.alias || [],
    redirect: languageEBOZlKblGyMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/settings/language.vue").then(m => m.default || m)
  },
  {
    name: _91id_93HdUcJMrijrMeta?.name ?? "service-settings-loginProviders-id",
    path: _91id_93HdUcJMrijrMeta?.path ?? "loginProviders/:id()",
    meta: _91id_93HdUcJMrijrMeta || {},
    alias: _91id_93HdUcJMrijrMeta?.alias || [],
    redirect: _91id_93HdUcJMrijrMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/settings/loginProviders/[id].vue").then(m => m.default || m)
  },
  {
    name: indexIVUg8IBdJqMeta?.name ?? "service-settings-loginProviders",
    path: indexIVUg8IBdJqMeta?.path ?? "loginProviders",
    meta: indexIVUg8IBdJqMeta || {},
    alias: indexIVUg8IBdJqMeta?.alias || [],
    redirect: indexIVUg8IBdJqMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/settings/loginProviders/index.vue").then(m => m.default || m)
  },
  {
    name: rolesSRaiIq4qvlMeta?.name ?? "service-settings-roles",
    path: rolesSRaiIq4qvlMeta?.path ?? "roles",
    meta: rolesSRaiIq4qvlMeta || {},
    alias: rolesSRaiIq4qvlMeta?.alias || [],
    redirect: rolesSRaiIq4qvlMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/settings/roles.vue").then(m => m.default || m)
  }
],
    meta: settingsdaMmZBXRTzMeta || {},
    alias: settingsdaMmZBXRTzMeta?.alias || [],
    redirect: settingsdaMmZBXRTzMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/settings.vue").then(m => m.default || m)
  },
  {
    path: usersXwvepQk4frMeta?.path ?? "users",
    children: [
  {
    name: _91id_93av9JmgWDuRMeta?.name ?? "service-users-id",
    path: _91id_93av9JmgWDuRMeta?.path ?? ":id()",
    children: [
  {
    name: userActivitiesBFtbXzBSz5Meta?.name ?? "service-users-id-userActivities",
    path: userActivitiesBFtbXzBSz5Meta?.path ?? "userActivities",
    meta: userActivitiesBFtbXzBSz5Meta || {},
    alias: userActivitiesBFtbXzBSz5Meta?.alias || [],
    redirect: userActivitiesBFtbXzBSz5Meta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/users/[id]/userActivities.vue").then(m => m.default || m)
  },
  {
    name: userBaseDataYlADgryv5tMeta?.name ?? "service-users-id-userBaseData",
    path: userBaseDataYlADgryv5tMeta?.path ?? "userBaseData",
    meta: userBaseDataYlADgryv5tMeta || {},
    alias: userBaseDataYlADgryv5tMeta?.alias || [],
    redirect: userBaseDataYlADgryv5tMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/users/[id]/userBaseData.vue").then(m => m.default || m)
  },
  {
    name: userCommunicationsCkkvdbwHoUMeta?.name ?? "service-users-id-userCommunications",
    path: userCommunicationsCkkvdbwHoUMeta?.path ?? "userCommunications",
    meta: userCommunicationsCkkvdbwHoUMeta || {},
    alias: userCommunicationsCkkvdbwHoUMeta?.alias || [],
    redirect: userCommunicationsCkkvdbwHoUMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/users/[id]/userCommunications.vue").then(m => m.default || m)
  }
],
    meta: _91id_93av9JmgWDuRMeta || {},
    alias: _91id_93av9JmgWDuRMeta?.alias || [],
    redirect: _91id_93av9JmgWDuRMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/users/[id].vue").then(m => m.default || m)
  },
  {
    name: indexXO1WDR2g8vMeta?.name ?? "service-users",
    path: indexXO1WDR2g8vMeta?.path ?? "",
    meta: indexXO1WDR2g8vMeta || {},
    alias: indexXO1WDR2g8vMeta?.alias || [],
    redirect: indexXO1WDR2g8vMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/users/index.vue").then(m => m.default || m)
  }
],
    name: usersXwvepQk4frMeta?.name ?? undefined,
    meta: usersXwvepQk4frMeta || {},
    alias: usersXwvepQk4frMeta?.alias || [],
    redirect: usersXwvepQk4frMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service/users.vue").then(m => m.default || m)
  }
],
    name: servicedgJ9UzNFaaMeta?.name ?? undefined,
    meta: servicedgJ9UzNFaaMeta || {},
    alias: servicedgJ9UzNFaaMeta?.alias || [],
    redirect: servicedgJ9UzNFaaMeta?.redirect || undefined,
    component: () => import("/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/pages/service.vue").then(m => m.default || m)
  }
]